/* eslint-disable @typescript-eslint/default-param-last */
import { PRESETS_SET } from '../presets/actions';
import { DEFAULT_PRESET_SET } from './actions';
import dotProp from 'dot-prop-immutable';

const initialState = null;

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PRESETS_SET:
      return action.payload;

    case DEFAULT_PRESET_SET:
      return dotProp.set(state, action.payload.key, { ...action.payload.properties });

    default:
      return state;
  }
};

export default reducer;
